import React, { useEffect, useState } from "react";
import moment from "moment";
import 'moment-timezone';
import { CMSpan } from "./countdown.styles";

moment.tz.setDefault("America/New_York");

const Countdown = ({ date, onCountdownEnd }) => {
  const [currentTime, setCurrentTime] = useState(moment.tz('America/New_York'));
  const [isCountdownEnded, setIsCountdownEnded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment.tz('America/New_York'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const targetTime = moment.tz(date, 'America/New_York');
    const timeBetween = targetTime.diff(currentTime);

    if (timeBetween <= 0 && !isCountdownEnded) {
      setIsCountdownEnded(true);
      if (onCountdownEnd) onCountdownEnd(true);
    }
  }, [currentTime, date, isCountdownEnded, onCountdownEnd]);

  const targetTime = moment.tz(date, 'America/New_York');
  const timeBetween = moment.duration(targetTime.diff(currentTime));

  return (
    <>
      {timeBetween.years() > 0 &&
        <CMSpan>{timeBetween.years()}y </CMSpan>
      }
      {timeBetween.months() > 0 &&
        <CMSpan>{timeBetween.months()}m </CMSpan>
      }
      {timeBetween.days() > 0 &&
        <CMSpan>{timeBetween.days()}d </CMSpan>
      }
      {timeBetween.hours() > 0 &&
        <CMSpan>{timeBetween.hours()}h </CMSpan>
      }
      <CMSpan>{timeBetween.minutes() > 0 ? timeBetween.minutes() : '0'}m </CMSpan>
      <CMSpan>{timeBetween.seconds() > 0 ? timeBetween.seconds() : '0'}s </CMSpan>
    </>
  );
};

export default Countdown;
